// Adapter around your existing church data source.
//
// You said church info currently lives in a churches.js file. Update the
// import below to point at wherever that file actually is in your project
// (e.g. '../data/churches' or '../churches'), and adjust the shape mapping
// if your file's export looks different from the guesses below.
//
// Once you build a real `churches` table in Supabase, swap the body of
// getChurches() for a supabase.from('churches').select('id, name') call —
// nothing else in the admin section needs to change. 

import { churches as rawChurches } from '../data/churches'; // <-- adjust this path

function normalize(raw) {
  if (!raw) return [];

  // Case 1: array of plain strings, e.g. ['Atlantis', 'Belhar', ...]
  if (typeof raw[0] === 'string') {
    return raw.map((name) => ({ id: name, name }));
  }

  // Case 2: array of objects, e.g. [{ id, name }, ...] or [{ name }, ...]
  return raw.map((c, i) => ({
    id: c.id ?? c.slug ?? String(i),
    name: c.name ?? c.title ?? String(c),
  }));
}

export function getChurches() {
  try {
    return normalize(rawChurches);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Could not load churches list — check the import path in src/lib/churches.js', err);
    return [];
  }
}
